import { render, staticRenderFns } from "./MediaImageGif.vue?vue&type=template&id=132508b7"
import script from "./MediaImageGif.vue?vue&type=script&lang=js"
export * from "./MediaImageGif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports